export enum ChartValues {
  DATAMAX = 'dataMax',
  DATAMIN = 'dataMin',
  NONE = 'none',
  CLICK = 'click',
  SCROLL = 'scroll',
  AXIS = 'axis',
  SHADOW = 'shadow',
  VALUE = 'value',
  LINE = 'line',
  SCATTER = 'scatter',
  CIRCLE = 'circle',
  LOG = 'log',
  BOLD = 'bold',
  CATEGORY = 'category',
  ITEM = 'item',
  BAR = 'bar',
  SQUARE = 'square'
}

export enum ChartSymbol {
  CIRCLE= 'circle',
  RECT = 'rect',
  ROUNDRECT = 'roundRect',
  TRIANGLE = 'triangle',
  DIAMOND = 'diamond',
  PIN = 'pin',
  ARROW = 'arrow',
  NONE = 'none'
}
export enum ChartColors {
  DEFAULT_LINE_COLOR = '#F5F6FA',
  DEFAULT_TEXT_COLOR = '#A3A6B4',
}

export enum ChartPosition {
  TOP_LEFT = '00',
  TOP_RIGHT = '01',
  BOTTOM_LEFT = '10',
  BOTTOM_RIGHT = '11',
  VERTICAL = 'vertical',
  CENTER = 'center',
  START = 'start',
  LEFT = 'left',
  BOTTOM = 'bottom',
  MIDDLE = 'middle',
  RIGHT = 'right',
}

export enum DataZoomAxis {
  X_AXIS = 'xAxis',
  Y_AXIS = 'yAxis'
}

export enum DataZoomType {
  SLIDER = 'slider',
  INSIDE = 'inside'
}

export enum DataZoomConfig {
  THICKNESS = 3,
  HANDLE_ICON = 'M10.7,11.9H9.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z',
}

export enum ScrollStartPosition {
  start = 0,
  end = 100,
}

export const VIEW_NAME: { [ k: string ]: string } = {
  LEAD_TIME: 'vLeadTime',
};

export const Default = 'default';
